import { render, staticRenderFns } from "./BookAppointmentDialog.vue?vue&type=template&id=e5dc45b6&scoped=true&"
import script from "./BookAppointmentDialog.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentDialog.vue?vue&type=style&index=0&id=e5dc45b6&scoped=true&lang=css&"
import style1 from "./BookAppointmentDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc45b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VDivider,VIcon})
